const SESSION_PARAMS_KEY = "webviewParams";

/**
 * True if the params have everything needed to open the app
 * @param {URLSearchParams} params
 */
function hasRequiredParams(params) {
    return params.has("t") && params.has("x") && params.has("a") && params.has("c");
}

/**
 * Recover object with URL params.
 * The router sends the credentials (token and api key) in the URL. They are kept in sessionStorage
 * and removed from the address bar, so they do not stay in the history or go in the Referer header.
 * A reload of the page (like the "send new message" button) takes them back from sessionStorage.
 */
function getUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    if (hasRequiredParams(urlParams)) {
        try {
            sessionStorage.setItem(SESSION_PARAMS_KEY, urlParams.toString());
            window.history.replaceState(null, "", window.location.pathname);
        } catch (error) {
            // Without sessionStorage the params stay in the URL, so a reload keeps working
            console.error("Could not keep the url params in sessionStorage");
        }
        return urlParams;
    }
    try {
        const sessionParams = new URLSearchParams(sessionStorage.getItem(SESSION_PARAMS_KEY) ?? "");
        return hasRequiredParams(sessionParams) ? sessionParams : null;
    } catch (error) {
        return null;
    }
}

export {getUrlParams};
